import useFetchReducer from 'src/hooks/useFetchReducer';
import { FetchState } from 'src/reducers/fetchReducer';
import ProductSummarySegment from '../types/ProductSummarySegment';
import ProductSummaryList from '../types/ProductSummaryList';
import { getProductSummary } from '../api/productSummary.api';

export type ProductSummaryListState = FetchState<ProductSummarySegment[]>;

type ProductSummaryListFetchProps = {
  matchType: string;
  ownerId: string;
  priceType: string;
  sourceOwnerId: string;
  sourceProductId: string;
  regionId: string;
};

const initialState: ProductSummaryListState = {
  loading: false,
  error: false,
  data: null,
};

const useProductSummaryListFetch = ({
  ownerId,
  sourceProductId,
  sourceOwnerId,
  matchType,
  priceType,
  regionId,
}: ProductSummaryListFetchProps): [ProductSummaryListState] => {
  const params: ProductSummaryList.Request = {
    ownerId,
    sourceProductId,
    sourceOwnerId,
    matchType,
    priceType,
    regionId,
  };

  const [{ loading, data, error }] = useFetchReducer(
    () => getProductSummary(params),
    [ownerId, sourceProductId, sourceOwnerId, matchType, priceType, regionId]
  );
  const state: ProductSummaryListState = { ...initialState, loading, error };

  if (data === null) {
    return [state];
  }

  return [
    {
      ...state,
      data,
    },
  ];
};

export default useProductSummaryListFetch;
